// Module
var code = "<template class=\"m-popover-template\" show.bind=\"showPopover\"> <div class=\"m-popover\"> <h3 if.bind=\"title\" class=\"m-popover-title\">${title}</h3> <div class=\"m-popover-body\"> <slot></slot> </div> </div> <div class=\"arrow\"></div> </template> ";
// Exports
export default code;